import axios from 'axios'

const backendUrl = process.env.VUE_APP_BACKEND_URL
const apiUri = process.env.VUE_APP_API_URI

const actions = {
  get ({ commit }, payload) {
    let endpoint = payload.endpoint
    let data = payload.data
    return new Promise((resolve, reject) => {
      axios.get(backendUrl + apiUri + endpoint, {
        params: data
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

export default {
  namespaced: true,
  actions
}
